import './main'
import Vue from 'vue'
import AppPrimarias from './AppPrimarias'

new Vue({
	render: h => h(AppPrimarias)
}).$mount('#app')
